var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3779 12.9467C27.1155 12.9716 26.8531 12.985 26.5907 12.987C23.7098 12.987 21.0224 11.535 19.4421 9.12343V22.277C19.4421 27.6461 15.0901 32 9.71914 32C4.34814 32 0 27.648 0 22.277C0 16.906 4.35197 12.5541 9.72297 12.5541C9.92601 12.5541 10.1252 12.5732 10.3244 12.5847V17.3753C10.1252 17.3523 9.92793 17.314 9.72297 17.314C6.98192 17.314 4.76188 19.536 4.76188 22.2751C4.76188 25.0162 6.98384 27.2362 9.72297 27.2362C12.464 27.2362 14.8852 25.0775 14.8852 22.3364L14.9312 0H19.5149C19.9478 4.11062 23.2616 7.32096 27.3837 7.62169V12.9467"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.0cb8d0c613c8c9b8ff5dac3e4ae48b4e.svg";
export { ForwardRef as ReactComponent };